export default __webpack_public_path__ + "static/media/success.70cff281.svg";